<template>
  <table class="w-100 table table-bordered evaluation-table">
    <tr>
      <th>{{ $t('scale') }}</th>
      <th>{{ t('perceptions')[0] }}</th>
      <th>{{ t('difficulties')[0] }}</th>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="4" /></td>
      <td v-html="t('perceptions')[1]"/>
      <td rowspan="2">{{ t('difficulties')[1] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="3" /></td>
      <td v-html="t('perceptions')[2]"/>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="2" /></td>
      <td v-html="t('perceptions')[3]"/>
      <td>{{ t('difficulties')[2] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="1" /></td>
      <td v-html="t('perceptions')[4]"/>
      <td rowspan="2">{{ t('difficulties')[3] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="0" /></td>
      <td v-html="t('perceptions')[5]"/>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'PerceptionsTable',

  methods: {
    t (key) {
      return this.$i18n.t('components.evaluations.perceptions.' + key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/evaluations/PerceptionsTable.vue